const Header = () => {
  const toggleSearch = document.querySelectorAll('.toggle-search')
  
  toggleSearch.forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelector('.search-block').classList.toggle('active')
    })
  })

  const toggleMenu = document.querySelectorAll('.toggle-menu')
  
  toggleMenu.forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelector('.menu-block').classList.toggle('active')
    })
  })
  
  const submenusMobile = document.querySelectorAll('.mobile-menu-block .menu-item-has-children > a')
  
  submenusMobile.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
     this.parentElement.classList.toggle('active')
    })
  })

  const submenusDesktop = document.querySelectorAll('.main-menu-block .menu-item-has-children')
  
  submenusDesktop.forEach(function (item) {
    let subitems = item.querySelectorAll('.menu-item');

    if(subitems.length >= 6){
      item.classList.add('cols');
    }
  })
  
  
  const openCloseModal = document.querySelectorAll(`[data-action="openCloseModal"]`)

  openCloseModal.forEach(function (btn) {
    btn.addEventListener('click', function () {
      let modal = document.querySelector(".access-count");
      modal.classList.toggle("active");
    })
  })

  const seepass = document.querySelectorAll('.btn-show-pass')

  seepass.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      let seePass = document.querySelector(".password-field");
      if (seePass.type === "password") {
        seePass.type = "text";
      } else {
        seePass.type = "password";
      }
    })
  })

  const openSelectorLang = document.querySelectorAll(`.modal-access .selected`)

  openSelectorLang.forEach(function (btn) {

    let btnStatus = false;

    btn.addEventListener('click', function () {
      btnStatus = !btnStatus
      if (!btnStatus){
        btn.blur()
      }
    })
    
    btn.addEventListener('focus', function () {
      let selectorLang = document.querySelector(".modal-access .lang-option .options");
      selectorLang.classList.toggle("active");      
    })

    btn.addEventListener('focusout', function () {
      let selectorLang = document.querySelector(".modal-access .lang-option .options");
      
      selectorLang.classList.toggle("active");
      
      btnStatus = false      
    })

    
  })

  const optionSelectorLang = document.querySelectorAll(`.modal-access .options .option`)

  optionSelectorLang.forEach(function (btn) {
    
    console.log(btn)

    btn.addEventListener('mousedown', function () {
      let action = btn.dataset.action
      let flag = btn.querySelector('.lang-flag img').src
      let country = btn.querySelector('.lang-name').textContent

      document.querySelector('.modal-access form').action = action 
      document.querySelector('.modal-access .selected .lang-flag .flag').src = flag
      document.querySelector('.modal-access .selected .lang-flag source').srcset = flag + '.webp'
      document.querySelector('.modal-access .selected .lang-name').textContent = country
    })
  })

}
  
export default Header